__turbopack_context__.v({
  "form": "search-form-module-scss-module___S6E2W__form",
  "form__address-fields": "search-form-module-scss-module___S6E2W__form__address-fields",
  "form__address-fields-item": "search-form-module-scss-module___S6E2W__form__address-fields-item",
  "form__button": "search-form-module-scss-module___S6E2W__form__button",
  "search-form-container": "search-form-module-scss-module___S6E2W__search-form-container",
});
